import { gql } from '@apollo/client';

export const fetchSubscriptionsForInvoiceGroup = gql`
  query fetchSubscriptionsForInvoiceGroup(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    invoiceGroup(id: $id) {
      id
      productSubscriptions(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          billingFrequency
          billingStatus
          entitlementNumber
          id
          latestPeriodEndDate
          latestPeriodStartDate
          productName
          productId
          edition
          cloudSiteHostname
          billedUsers
          trial
          isSandbox
          isApp
          nextBillingTimestamp
        }
      }
    }
  }
`;
